import { CookieKeys } from "../constants/cookieKeys";

export const getCookie = (name: CookieKeys) => {
  if (typeof document === "undefined") {
    return undefined;
  }

  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));

  return match ? decodeURIComponent(match[2]) : undefined;
};
